const createRegExp = projectNiceIds => {
    const regex = `(${projectNiceIds})-(\\d+)`;

    return {
        scanRE: RegExp(regex),
        replaceRE: RegExp(regex, 'g')
    }
}

const createRule = md => {
    const arrayReplaceAt = md.utils.arrayReplaceAt;
    const ucm = md.utils.lib.ucmicro;
    const ZPCc = new RegExp([ ucm.Z.source, ucm.P.source, ucm.Cc.source ].join('|'));

    const splitTextToken = (text, level, Token, replaceRE) => {
        const nodes = [];
        let lastPos = 0;
        let token;

        text.toUpperCase().replace(replaceRE, (match, projectNiceId, taskIdx, offset, src) => {
            // replace shortcut with full name
            const taskNiceId = `${projectNiceId}-${taskIdx}`;

            // Don't allow letters before any shortcut (as in no ":/" in http://)
            if (offset > 0 && !ZPCc.test(src[offset - 1])) {
                return;
            }

            // Don't allow letters after any shortcut
            if (offset + match.length < src.length && !ZPCc.test(src[offset + match.length])) {
                return;
            }

            // Add new tokens to pending list
            if (offset > lastPos) {
                token = new Token('text', '', 0);
                token.content = text.slice(lastPos, offset);
                nodes.push(token);
            }

            token = new Token('task', '', 0);
            token.attrs = [
                ['niceId', taskNiceId.toUpperCase()]
            ];

            token.content = ''; // set content
            nodes.push(token);

            lastPos = offset + match.length;

        });

        if (lastPos < text.length) {
            token = new Token('text', '', 0);
            token.content = text.slice(lastPos);
            nodes.push(token);
        }

        return nodes;
    }

    return state => {
        const { scanRE, replaceRE } = createRegExp(md.customResources.projectNiceIds);

        var i, j, l, tokens, token,
                blockTokens = state.tokens,
                autolinkLevel = 0;

        for (j = 0, l = blockTokens.length; j < l; j++) {
            if (blockTokens[j].type !== 'inline') { continue; }
            tokens = blockTokens[j].children;

            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for (i = tokens.length - 1; i >= 0; i--) {
                token = tokens[i];

                if (token.type === 'link_open' || token.type === 'link_close') {
                    if (token.info === 'auto') { autolinkLevel -= token.nesting; }
                }

                if (token.type === 'text' && autolinkLevel === 0 && scanRE.test(token.content.toUpperCase())) {
                    // replace current node
                    blockTokens[j].children = tokens = arrayReplaceAt(
                        tokens, i, splitTextToken(token.content, token.level, state.Token, replaceRE)
                    );
                }
            }
        }
    };
};

export default function plugin(md, options) {
    md.core.ruler.push('task', createRule(md));
};
